// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2nO0b","addWidgetButton":"Header_addWidgetButton__20VlS","dashboardTabs":"Header_dashboardTabs__D2guS","active":"Header_active__2i7md"};